(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["process_steps"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Add SVG path animation if desired
  const path = document.querySelector('.process-steps-path path');
  
  if (path) {
    path.style.strokeDashoffset = path.getTotalLength();
    path.style.strokeDasharray = path.getTotalLength();
    path.style.transition = 'stroke-dashoffset 1.5s ease-in-out';
    
    setTimeout(function() {
      path.style.strokeDashoffset = '0';
    }, 500);
  }
});

  } catch(e) { console.error(e); }
})();
})();
